import React from "react";
import { CATEGORIES } from "../../lib/game";

const FACE_TRANSFORM = {
  1: { x: 0, y: 0 },
  2: { x: 0, y: -180 },
  3: { x: 0, y: -90 },
  4: { x: 0, y: 90 },
  5: { x: -90, y: 0 },
  6: { x: 90, y: 0 },
};

// Which category sits on each cube face
const FACES = [
  { cls: "f-front", cat: "SAVE" },
  { cls: "f-back", cat: "EARN" },
  { cls: "f-right", cat: "INVEST" },
  { cls: "f-left", cat: "SPEND" },
  { cls: "f-top", cat: "LIFE_EVENT" },
  { cls: "f-bottom", cat: "DEBT" },
];

export const Dice = ({ face, spins }) => {
  const rest = FACE_TRANSFORM[face || 1];
  const transform = `rotateX(${360 * spins + rest.x}deg) rotateY(${360 * spins + rest.y}deg)`;

  return (
    <div className="dice-scene" data-testid="dice-cube">
      <div className="dice-cube" style={{ transform }}>
        {FACES.map(({ cls, cat }) => {
          const meta = CATEGORIES[cat];
          const Icon = meta.Icon;
          return (
            <div
              key={cls}
              className={`dice-face ${cls}`}
              style={{ background: meta.hex }}
            >
              <div className="flex flex-col items-center justify-center gap-1 text-slate-950">
                <Icon className="w-7 h-7" strokeWidth={2.4} />
                <span className="text-[10px] font-bold uppercase tracking-wider leading-none">
                  {meta.label}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
